<template>
  <div
    class="intro-y flex flex-col lg:flex-row justify-between lg:items-end gap-0 lg:gap-2 mt-8"
  >
    <div class="flex flex-row items-end">
      <div
        class="bg-green-600 px-8 py-2 lg:text-2xl font-bold text-white text-center rounded-md"
      >
        OF
      </div>
      <h2 class="text-lg font-medium ml-4">
        {{ formOF.ofEdit ? 'แก้ไข OF ' + formOF.ofNo : 'สร้าง OF' }}
      </h2>
      <OverBudget />
    </div>
    <div
      class="flex flex-row justify-end mt-4 lg:mt-0 gap-2"
      v-if="!loadingPage"
    >
      <router-link
        type="button"
        :to="{ name: 'preorderOFList' }"
        class="btn box text-gray-700 flex items-center text-xs"
      >
        <ArrowLeftIcon class="w-4 h-4 mr-2 hidden md:block" /> Back
      </router-link>
      <a
        href="javascript:;"
        class="btn btn-danger disabled:opacity-50 flex items-center"
        data-toggle="modal"
        data-target="#cancel-modal-preview"
        :disabled="btnCancel.disabled"
        v-show="!btnCancel.hide"
      >
        <XCircleIcon
          class="w-4 h-4 mr-2 hidden md:block"
          v-if="!btnCancel.loading"
        />
        <LoadingIcon icon="oval" color="white" v-else class="w-4 h-4 mr-2" />
        ยกเลิกเอกสาร
      </a>
      <button
        type="button"
        class="btn btn-danger disabled:opacity-50 flex items-center"
        @click.prevent="rejectOF()"
        :disabled="btnReject.disabled"
        v-show="!btnReject.hide"
      >
        <ArrowLeftIcon
          class="w-4 h-4 mr-2 hidden md:block"
          v-if="!btnReject.loading"
        />
        <LoadingIcon icon="oval" color="white" v-else class="w-4 h-4 mr-2" />
        ดึงเอกสารกลับ
      </button>
      <button
        type="button"
        class="btn box text-gray-700 disabled:opacity-50 flex items-center"
        @click.prevent="saveOF(true)"
        :disabled="btnDraft.disabled"
        v-show="!btnDraft.hide"
      >
        <FileTextIcon
          class="w-4 h-4 mr-2 hidden md:block"
          v-if="!btnDraft.loading"
        />
        <LoadingIcon icon="oval" color="blue" v-else class="w-4 h-4 mr-2" />
        บันทึกแบบร่าง
      </button>
      <button
        type="button"
        class="btn btn-primary disabled:opacity-50 flex items-center"
        @click.prevent="saveOF(false)"
        :disabled="btnSave.disabled"
        v-show="!btnSave.hide"
      >
        <FileTextIcon
          class="w-4 h-4 mr-2 hidden md:block"
          v-if="!btnSave.loading"
        />
        <LoadingIcon icon="oval" color="white" v-else class="w-4 h-4 mr-2" />
        บันทึก และส่งอนุมัติ
      </button>
    </div>
  </div>
  <div class="grid grid-cols-12 gap-6 mt-0 lg:mt-5">
    <div class="intro-y col-span-12">
      <div class="mt-5">
        <div class="h-10 w-full text-center my-20" v-if="loadingPage">
          <LoadingIcon icon="oval" class="w-12 h-12" />
        </div>
        <div class="horizontal-form" v-else>
          <div class="mb-5" v-if="formOF.isEdit">
            <DocumentPath
              :document-path="formOF.documentPathArray"
              :status-code="formOF.statusCode"
              :next-status-code="formOF.nextStatus"
              :approve-result="formOF.approveResultArray"
            />
          </div>
          <div class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5">
            <div class="col-span-1 md:mr-4 box flex flex-col justify-center">
              <div
                class="w-full h-auto flex flex-row justify-center bg-white p-4"
              >
                <img
                  v-if="companyDefault"
                  :src="companyDefault.comp_logo_url"
                  class=""
                  alt=""
                />
              </div>
            </div>
            <div class="col-span-2 lg:col-span-4 mt-4 md:mt-0">
              <!-- ตำแหน่งเอกสาร -->
              <div class="intro-y box p-5">
                <div class="flex flex-col lg:flex-row lg:space-x-4">
                  <div class="text-theme-6">
                    ตำแหน่งเอกสาร : ผู้ขอเบิกสร้างเอกสาร
                  </div>
                  <div class="text-theme-10">
                    ผู้ดำเนินการ : {{ userInfo ? userInfo.fullname : '' }}
                  </div>
                </div>
              </div>
              <!-- สายอนุมัติของผู้เปิดเอกสาร -->
              <div class="intro-y box p-5 mt-5 lg:flex lg:justify-between">
                <div>
                  <div>สายอนุมัติของผู้เปิดเอกสาร :</div>
                  <div class="font-bold">
                    {{
                      documentPathText
                        ? documentPathText.join(' -> ')
                        : 'ไม่ระบุ'
                    }}
                  </div>
                </div>
                <!-- <div>
                  <select
                    v-model="specialPathSelected"
                    class="form-control form-select"
                    @change="
                      onChangeDocumentPath({ target: 'select-special-path' })
                    "
                  >
                    <option :value="null"
                      >ตรวจสอบสายอนุมัติของผู้เปิดเอกสารตามวงเงิน</option
                    >
                    <option
                      v-for="spacialPath in documentSpacialPathOptions"
                      :key="spacialPath.name"
                      :value="spacialPath.name"
                      >{{ spacialPath.name }}</option
                    >
                  </select>
                </div> -->
              </div>
            </div>
          </div>
          <div class="box intro-y mt-5 p-5">
            <div class="text-lg font-bold">
              ข้อมูลผู้สร้างเอกสาร
            </div>
            <div class="grid grid-cols-1 lg:grid-cols-4 gap-4 mt-5">
              <!-- ชื่อผู้ขอเบิก -->
              <div>
                <div class="w-full">
                  <label class="form-label">ชื่อผู้ขอเบิก </label>
                  <div class="preview w-full">
                    <WfSelectSingleEmployee
                      :disabled="lockField.status"
                      key="wfselect-employee"
                      v-model="formOF.employeeSelected"
                      :showBtnClear="false"
                      :options="{
                        searchMinLength: 3
                      }"
                      @change="onChangeDocumentPath"
                    ></WfSelectSingleEmployee>
                  </div>
                  <span class="text-theme-6" v-show="lockField.status">{{
                    lockField.label
                  }}</span>
                </div>
              </div>
              <!-- หน่วยงาน / บริษัท -->
              <div>
                <label class="form-label">หน่วยงาน / บริษัท </label>
                <select
                  name=""
                  v-model="formOF.companySelected"
                  @change="onChangeDocumentPath({ target: 'select-company' })"
                  class="form-select w-full"
                  :disabled="lockField.status"
                >
                  <option
                    v-for="company in companyOptions"
                    :key="company.comp_no"
                    :value="company.comp_no"
                    >{{ company.comp_name_th }}</option
                  >
                </select>
                <span class="text-theme-6" v-show="lockField.status">{{
                  lockField.label
                }}</span>
              </div>
              <!-- รหัสหน่วยงาน -->
              <div>
                <label class="form-label">รหัสหน่วยงาน</label>
                <div class="" v-if="employeeDefault">
                  {{ employeeDefault.bu_no }} ({{ employeeDefault.bu_name }})
                </div>
              </div>
              <!-- เบอร์ติดต่อ -->
              <div>
                <label class="form-label"
                  >เบอร์ติดต่อ <span class="text-theme-6">*</span></label
                >
                <div>
                  <input
                    type="text"
                    refs="titleRef"
                    v-model="validateOF.telephone.$model"
                    class="form-control w-full"
                    :class="{
                      'border-theme-6': validateOF.telephone.$error
                    }"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="grid grid-cols-1 mt-5 gap-4">
            <!-- ข้อมูลการขอซื้อ -->
            <div class="intro-y box p-5">
              <div class="font-bold text-lg">ข้อมูลการขอซื้อ</div>
              <div class="grid grid-cols-1 lg:grid-cols-3 lg:gap-4">
                <div class="col-span-1">
                  <!-- สกุลเงิน -->
                  <div class="mt-4">
                    <label class="form-label"
                      >สกุลเงิน <span class="text-theme-6">*</span></label
                    >
                    <div class="font-bold w-full">
                      <select
                        name=""
                        v-model="validateOF.currencySelected.$model"
                        class="form-select form-control"
                        :class="{
                          'border-theme-6': validateOF.currencySelected.$error
                        }"
                      >
                        <option
                          v-for="(currency, ind) in currencyOptions"
                          :key="ind"
                          :value="currency"
                          >{{ currency }}</option
                        >
                      </select>
                    </div>
                  </div>
                  <!-- ชนิดของการซื้อ -->
                  <div class="mt-4">
                    <label class="form-label"
                      >ชนิดของการซื้อ
                      <span class="text-theme-6" v-show="lockField.status">{{
                        lockField.label
                      }}</span></label
                    >
                    <div class="font-bold w-full">
                      <select
                        name=""
                        :disabled="lockField.status"
                        v-model="formOF.orderTypeSelected"
                        class="form-select form-control"
                      >
                        <option
                          v-for="type in orderTypeOptions"
                          :key="type.value"
                          :value="type.value"
                        >
                          {{ type.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="box intro-y mt-5 p-5">
            <div class="font-bold text-lg grid grid-cols-1 lg:grid-cols-4 ">
              <div class="col-span-3">รายละเอียดการขอซื้อ</div>
              <div class="col-span-1">
                <div
                  v-if="formOF.ofRefInfo.docNoFull"
                  class="mr-2 text-gray-600"
                >
                  อ้างอิงจากเลขที่เอกสาร ({{ formOF.ofRefInfo.docNoFull }})
                </div>
              </div>
            </div>
            <div class="grid grid-cols-1 lg:grid-cols-4 lg:gap-4">
              <div class="col-span-3">
                <div class="mt-4">
                  <label class="form-label"
                    >รายละเอียด <span class="text-theme-6">*</span></label
                  >
                  <!-- <textarea
                    name=""
                    id=""
                    rows="11"
                    v-model="validateOF.detail.$model"
                    class="form-control"
                    :class="{ 'border-theme-6': validateOF.telephone.$error }"
                    placeholder="เพิ่มเติม..."
                  ></textarea> -->
                  <div
                    :class="{
                      'border-theme-6 border': validateOF.detail.$error
                    }"
                  >
                    <TextEditor v-model="validateOF.detail.$model" />
                  </div>
                </div>
              </div>
              <div>
                <!-- <div
                  v-if="formOF.ofRefInfo"
                  class="mr-2 text-gray-600 lg:hidden"
                >
                  อ้างอิงจากเลขที่เอกสาร ({{ formOF.ofRefInfo.docNoFull }})
                </div> -->
                <!-- เลือกเอกสารจาก Memo -->
                <div class="mt-4">
                  <label for="" class="form-label">เลือกเอกสารจาก Memo</label>
                  <MemoAutoComplete
                    :options="memoOptions"
                    v-model="formOF.memoSelected"
                    v-model:selectedMemo="selectedMemo"
                  />
                  <!-- <div>
                    <select
                      name=""
                      v-model="formOF.memoSelected"
                      class="form-select form-control w-full"
                    >
                      <option :value="null" key="0">-- Select Memo --</option>
                      <option
                        v-for="memo in memoOptions"
                        :key="memo.doc_no"
                        :value="memo.id"
                        >{{ memo.doc_no }} - {{ memo.title }}</option
                      >
                    </select>
                  </div> -->
                </div>
                <!-- ไฟล์แนบ -->
                <div class="mt-4 col-span-1">
                  <label class="form-label"
                    >ไฟล์แนบ {{ fileUploadMaxSize }} MB</label
                  >
                  <AttachFileUpload module="of" />
                </div>
              </div>
            </div>
          </div>

          <!-- PR Item -->
          <div class="grid grid-cols-1 mt-5 box intro-y" v-show="boxItemOpen">
            <div class="box p-5">
              <div class="text-lg font-bold mb-4">ระบุรายการสินค้า</div>
              <div class="border p-5 rounded-lg mb-4">
                <div class="text-lg mb-4">รายละเอียดสินค้า</div>
                <div class="grid grid-cols-1 lg:grid-cols-3 lg:gap-4">
                  <div class="space-y-4">
                    <!-- เลือกสินค้า -->
                    <div class="">
                      <label for="" class="form-label"
                        >เลือกสินค้า <span class="text-theme-6">*</span>
                      </label>
                      <div class="">
                        <a
                          class="w-full btn btn-warning"
                          href="javascript:;"
                          data-toggle="modal"
                          data-target="#modal-material"
                        >
                          รายการสินค้า
                        </a>
                      </div>
                    </div>
                    <!-- หมวดหมู่สินค้า -->
                    <div class="">
                      <label for="material-gl-category" class="form-label"
                        >หมวดหมู่สินค้า</label
                      >
                      <input
                        type="text"
                        id="material-gl-category"
                        class="form-control"
                        disabled
                        v-model="formOFItem.materialInfo.material_group"
                      />
                    </div>
                    <!-- ชนิดสินค้า -->
                    <!-- <div class="">
                      <label for="material-type" class="form-label"
                        >ชนิดสินค้า</label
                      >
                      <input
                        type="text"
                        id="material-type"
                        class="form-control"
                        disabled
                        v-model="formOFItem.materialInfo.material_type"
                      />
                    </div> -->
                    <!-- รหัสสินค้า -->
                    <!-- <div class="">
                      <label for="material-code" class="form-label"
                        >รหัสสินค้า</label
                      >
                      <input
                        type="text"
                        id="material-code"
                        class="form-control"
                        disabled
                        v-model="formOFItem.materialInfo.material_code"
                      />
                    </div> -->
                    <!-- รหัสชนิดสินค้า -->
                    <div class="">
                      <label for="material-description-code" class="form-label"
                        >รหัสชนิดสินค้า</label
                      >
                      <input
                        type="text"
                        id="material-description-code"
                        class="form-control"
                        disabled
                        v-model="formOFItem.materialInfo.description_code"
                      />
                    </div>
                    <div class="">
                      <label for="" class="form-label "
                        >Vendor <span class="text-theme-6">*</span></label
                      >
                      <div class="preview w-full">
                        <WfSelectSingleVendor
                          key="wfselect-item-vendor"
                          v-model="validateItem.vendorSelected.$model"
                          :invalid="validateItem.vendorSelected.$error"
                          :options="{
                            ajaxLimit: 50,
                            searchMinLength: 3
                          }"
                        ></WfSelectSingleVendor>
                        <span
                          class="text-theme-6"
                          v-if="validateItem.vendorSelected.$error"
                          >{{
                            validateItem.vendorSelected.required.$message
                          }}</span
                        >
                      </div>
                    </div>
                    <div>
                      <label for="" class="form-label"
                        >เงื่อนไขการชำระเงิน <span class="text-theme-6">*</span>
                      </label>
                      <div class="">
                        <select
                          id="material-type"
                          class="form-select form-control w-full"
                          v-model="validateItem.paymentSelected.$model"
                          :class="{
                            'border-theme-6':
                              validateItem.paymentSelected.$error
                          }"
                        >
                          <option :value="null" key="0"
                            >-- เลือกเงื่อนไขการชำระเงิน --</option
                          >
                          <option
                            :value="payment"
                            v-for="payment in paymentTermAllOptions"
                            :key="payment.name"
                            >{{ payment.name }}</option
                          >
                        </select>
                        <span
                          class="text-theme-6"
                          v-if="validateItem.paymentSelected.$error"
                          >{{
                            validateItem.paymentSelected.required.$message
                          }}</span
                        >
                      </div>
                    </div>
                    <div>
                      <label class="form-label">เงื่อนไขการส่งสินค้า </label>
                      <div>
                        <select
                          name=""
                          v-model="formOFItem.shippingConditionSendSelected"
                          class="form-select form-control"
                        >
                          <option :value="null">เลือก</option>
                          <option
                            v-for="(shippingRecipient,
                            ind) in shippingRecipientOption"
                            :key="ind"
                            :value="shippingRecipient.value"
                            >{{ shippingRecipient.label }}</option
                          >
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-span-2">
                    <!-- รายการสินค้า -->
                    <div class="mb-3">
                      <label for="material-description" class="form-label"
                        >รายการสินค้า <span class="text-theme-6">*</span></label
                      >
                      <textarea
                        id="material-description"
                        rows="5"
                        class="form-control"
                        :class="{
                          'border-theme-6':
                            validateItem.materialInfo.description.$error
                        }"
                        v-model="validateItem.materialInfo.description.$model"
                      ></textarea>
                      <span
                        class="text-theme-6"
                        v-if="validateItem.materialInfo.description.$error"
                        >{{
                          validateItem.materialInfo.description.required
                            .$message
                        }}</span
                      >
                    </div>
                    <div class="grid grid-cols-1 lg:grid-cols-2 lg:gap-4">
                      <div class="space-y-4">
                        <!-- คงเหลือ -->
                        <div class="">
                          <label for="material-stock" class="form-label"
                            >คงเหลือ
                          </label>
                          <div class="input-group">
                            <input
                              type="text"
                              id="material-stock"
                              aria-label="stock"
                              aria-describedby="material-stock"
                              class="form-control"
                              readonly
                              min="0"
                              v-model.number="formOFItem.materialInfo.stock_qty"
                            />
                            <div class="input-group-text">
                              {{
                                formOFItem.materialInfo.stock_unit_name ?? '-'
                              }}
                            </div>
                          </div>
                        </div>
                        <!-- วันที่ต้องการใช้ -->
                        <div class="p-fluid p-grid">
                          <div class="p-field p-field-sm">
                            <label for=""
                              >วันที่ต้องการใช้
                              <span class="text-theme-6">*</span></label
                            >
                            <Calendar
                              class="mt-2"
                              inputStyle="padding:0.5rem 0.75rem;"
                              :inputClass="
                                validateItem.useDate.$error ? 'p-invalid' : ''
                              "
                              v-model="validateItem.useDate.$model"
                              dateFormat="yy-mm-dd"
                              placeholder="2022-01-01"
                            />
                            <span
                              class="text-theme-6"
                              v-if="validateItem.useDate.$error"
                              >{{
                                validateItem.useDate.required.$message
                              }}</span
                            >
                          </div>
                        </div>
                        <div class="">
                          <!-- <label for="" class="form-label "
                            >วันที่ต้องการใช้</label
                          >
                          <input
                            type="date"
                            class="form-control"
                            v-model="validateItem.useDate.$model"
                            :class="{
                              'border-theme-6': validateItem.useDate.$error
                            }"
                          /> -->
                          <!-- <Litepicker
                            v-model="validateItem.useDate.$model"
                            :class="{
                              'border-theme-6': validateItem.useDate.$error
                            }"
                            :options="{
                              autoApply: false,
                              showWeekNumbers: true,
                              dropdowns: {
                                minYear: 1990,
                                months: true,
                                maxYear: null,
                                years: true
                              },
                              format: 'YYYY-MM-DD'
                            }"
                            class="form-control"
                          /> -->
                          <!-- <span
                            class="text-theme-6"
                            v-if="validateItem.useDate.$error"
                            >{{ validateItem.useDate.required.$message }}</span
                          > -->
                        </div>
                        <!-- สถานที่รับสินค้า -->
                        <div class="">
                          <label for="material-pickup-loc" class="form-label"
                            >สถานที่รับสินค้า
                            <span class="text-theme-6">*</span></label
                          >
                          <textarea
                            id="material-pickup-loc"
                            rows="5"
                            class="form-control"
                            :class="{
                              'border-theme-6': validateItem.pickupLoc.$error
                            }"
                            v-model="validateItem.pickupLoc.$model"
                            placeholder="เพิ่มเติม..."
                          ></textarea>
                          <span
                            class="text-theme-6"
                            v-if="validateItem.pickupLoc.$error"
                            >{{
                              validateItem.pickupLoc.required.$message
                            }}</span
                          >
                        </div>
                      </div>
                      <div class="space-y-4">
                        <div class="grid grid-cols-2 gap-2">
                          <!-- หน่วยนับ -->
                          <div class="">
                            <label for="material-type" class="form-label"
                              >หน่วยนับ
                              <span class="text-theme-6">*</span></label
                            >
                            <select
                              id="material-type"
                              class="form-select form-control w-full"
                              v-model="validateItem.uomSelected.$model"
                              :class="{
                                'border-theme-6':
                                  validateItem.uomSelected.$error
                              }"
                            >
                              <option :value="null" key="0"
                                >-- เลือกหน่วยนับ --</option
                              >
                              <option
                                :value="uom.value.trim()"
                                v-for="uom in uomOptions"
                                :key="uom.value"
                                >{{ uom.label }}</option
                              >
                            </select>
                            <span
                              class="text-theme-6"
                              v-if="validateItem.uomSelected.$error"
                              >{{
                                validateItem.uomSelected.required.$message
                              }}</span
                            >
                          </div>
                          <!-- ราคาต่อหน่วย -->
                          <div class="">
                            <label for="material-price" class="form-label"
                              >ราคาต่อหน่วย
                              <span class="text-theme-6">*</span></label
                            >
                            <input
                              type="number"
                              id="material-price"
                              class="form-control"
                              min="0"
                              :class="{
                                'border-theme-6':
                                  validateItem.materialInfo.price.$error
                              }"
                              v-model.number="
                                validateItem.materialInfo.price.$model
                              "
                              @keyup="summaryAmount"
                              @change="summaryAmount"
                            />
                            <span
                              class="text-theme-6"
                              v-if="validateItem.materialInfo.price.$error"
                              >{{
                                validateItem.materialInfo.price.required
                                  .$message
                              }}</span
                            >
                          </div>
                        </div>

                        <div class=" gap-2">
                          <!-- จำนวนหน่วย -->
                          <div class="">
                            <label for="material-quality" class="form-label"
                              >จำนวนหน่วย
                              <span class="text-theme-6">*</span></label
                            >
                            <input
                              type="number"
                              id="material-quality"
                              class="form-control"
                              min="0"
                              :class="{
                                'border-theme-6': validateItem.qty.$error
                              }"
                              v-model.number="validateItem.qty.$model"
                              @keyup="summaryAmount"
                              @change="summaryAmount"
                            />
                            <span
                              class="text-theme-6"
                              v-if="validateItem.qty.$error"
                              >{{ validateItem.qty.required.$message }}</span
                            >
                          </div>
                          <!-- ราคาการแปลงหน่วย -->
                          <!-- <div class="">
                            <label
                              for="material-unit-conversion-pos"
                              class="form-label"
                              >ค่าแปลงหน่วย จาก 1 {{ uomCurrent.label ?? '' }}
                              <span class="text-theme-6">*</span></label
                            >
                            <div class="input-group">
                              <input
                                type="number"
                                id="material-unit-conversion-pos"
                                class="form-control"
                                min="0"
                                :class="{
                                  'border-theme-6':
                                    validateItem.unitConversionPos.$error
                                }"
                                v-model.number="
                                  validateItem.unitConversionPos.$model
                                "
                              />
                              <div class="input-group-text">
                                {{
                                  formOFItem.materialInfo.stock_unit_name ?? '-'
                                }}
                              </div>
                            </div>
                            <span
                              class="text-theme-6"
                              v-if="validateItem.unitConversionPos.$error"
                              >{{
                                validateItem.unitConversionPos.requiredIf
                                  .$message
                              }}</span
                            >
                          </div> -->
                        </div>

                        <div class="space-y-4">
                          <!-- ราคาก่อน vat -->
                          <div class="">
                            <label for="material-amount" class="form-label"
                              >ราคาก่อนรวมภาษี
                              <span class="text-theme-6">*</span></label
                            >
                            <input
                              type="number"
                              id="material-amount"
                              class="form-control"
                              min="0"
                              :class="{
                                'border-theme-6': validateItem.amount.$error
                              }"
                              v-model.number="validateItem.amount.$model"
                              @keyup="summaryActualCost"
                              @change="summaryActualCost"
                            />
                            <span
                              class="text-theme-6"
                              v-if="validateItem.amount.$error"
                              >{{ validateItem.amount.required.$message }}</span
                            >
                          </div>
                        </div>
                        <!-- ภาษีมูลค่าเพิ่ม -->
                        <div class="">
                          <label for="material-vat" class="form-label "
                            >ภาษีมูลค่าเพิ่ม</label
                          >
                          <div class="grid grid-cols-4 space-x-2">
                            <input
                              type="number"
                              id="material-vat"
                              class="form-control col-span-3"
                              v-model.number="formOFItem.vat"
                              min="0"
                              @keyup="calVat"
                              @change="calVat"
                            />
                            <input
                              type="number"
                              class="form-control"
                              v-model.number="formOFItem.taxVatDefault"
                              min="0"
                              max="100"
                              @change="calVatRate"
                            />
                          </div>
                        </div>
                        <!-- Actual Cost -->
                        <div class="">
                          <label for="material-actualCost" class="form-label"
                            >Actual Cost
                            <span class="text-theme-6">*</span></label
                          >
                          <input
                            type="number"
                            id="material-actualCost"
                            class="form-control"
                            min="0"
                            :class="{
                              'border-theme-6': validateItem.actualCost.$error
                            }"
                            v-model.number="validateItem.actualCost.$model"
                          />
                          <span
                            class="text-theme-6"
                            v-if="validateItem.actualCost.$error"
                            >{{
                              validateItem.actualCost.required.$message
                            }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="border p-5 rounded-lg">
                <div class="text-lg mb-4">รายละเอียดงบประมาณ</div>
                <div class="grid grid-cols-1 lg:grid-cols-3 lg:gap-4">
                  <div class="mb-4 space-y-4">
                    <div class="">
                      <label for="" class="form-label "
                        >ค้นหางบประมาณหน่วยงาน</label
                      >
                      <div class="">
                        <a
                          class="w-full btn btn-warning"
                          href="javascript:;"
                          data-toggle="modal"
                          data-target="#modal-budget"
                        >
                          รายการงบประมาณหน่วยงาน
                        </a>
                      </div>
                    </div>
                    <div class="">
                      <label for="" class="form-label "
                        >ค้นหางบประมาณโครงการ</label
                      >
                      <div class="">
                        <a
                          class="w-full btn btn-warning"
                          :class="[
                            !isProjectBudgetEnable ? 'btn-disabled' : ''
                          ]"
                          href="javascript:;"
                          :data-toggle="
                            `${isProjectBudgetEnable ? 'modal' : ''}`
                          "
                          :data-target="
                            `${isProjectBudgetEnable ? '#modal-ledget' : ''}`
                          "
                        >
                          รายการงบประมาณโครงการ
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="mb-4 space-y-4">
                    <!-- ปีงบประมาณ -->
                    <div class="">
                      <label for="" class="form-label">ปีงบประมาณ</label>
                      <input
                        type="text"
                        class="form-control"
                        readonly
                        v-model="validateItem.budgetInfo.year.$model"
                        :class="{
                          'border-theme-6': validateItem.budgetInfo.year.$error
                        }"
                      />
                      <span
                        class="text-theme-6"
                        v-if="validateItem.budgetInfo.year.$error"
                        >{{
                          validateItem.budgetInfo.year.required.$message
                        }}</span
                      >
                    </div>
                    <!-- ชนิดงบประมาณ -->
                    <div class="">
                      <label for="" class="form-label ">ชนิดงบประมาณ</label>
                      <input
                        type="text"
                        class="form-control"
                        readonly
                        v-model="validateItem.budgetInfo.bu_type.$model"
                        :class="{
                          'border-theme-6':
                            validateItem.budgetInfo.bu_type.$error
                        }"
                      />
                      <span
                        class="text-theme-6"
                        v-if="validateItem.budgetInfo.bu_type.$error"
                        >{{
                          validateItem.budgetInfo.bu_type.required.$message
                        }}</span
                      >
                    </div>
                    <!-- ใช้งบประมาณของหน่วยงาน -->
                    <div class="">
                      <label for="" class="form-label"
                        >ใช้งบประมาณของหน่วยงาน</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        readonly
                        v-model="validateItem.budgetInfo.bu_name.$model"
                        :class="{
                          'border-theme-6':
                            validateItem.budgetInfo.bu_name.$error
                        }"
                      />
                      <span
                        class="text-theme-6"
                        v-if="validateItem.budgetInfo.bu_name.$error"
                        >{{
                          validateItem.budgetInfo.bu_name.required.$message
                        }}</span
                      >
                    </div>
                    <!-- รหัสงบประมาณ -->
                    <div class="">
                      <label for="" class="form-label">รหัสงบประมาณ</label>
                      <input
                        type="text"
                        class="form-control"
                        readonly
                        v-model="validateItem.budgetInfo.bu_code.$model"
                        :class="{
                          'border-theme-6':
                            validateItem.budgetInfo.bu_code.$error
                        }"
                      />
                      <span
                        class="text-theme-6"
                        v-if="validateItem.budgetInfo.bu_code.$error"
                        >{{
                          validateItem.budgetInfo.bu_code.required.$message
                        }}</span
                      >
                    </div>
                  </div>
                  <div class="mb-4 space-y-4">
                    <!-- Account code -->
                    <div class="">
                      <label for="" class="form-label ">Account Code</label>
                      <input
                        type="text"
                        class="form-control"
                        readonly
                        v-model="formOFItem.budgetInfo.account_code"
                      />
                    </div>
                    <!-- Subsidiary -->
                    <div class="">
                      <label for="" class="form-label ">Subsidiary</label>
                      <input
                        type="text"
                        class="form-control"
                        readonly
                        v-model="formOFItem.budgetInfo.subsidiary"
                      />
                    </div>
                    <!-- Account name -->
                    <div class="">
                      <label for="" class="form-label ">Account Name</label>
                      <input
                        type="text"
                        class="form-control"
                        readonly
                        v-model="formOFItem.budgetInfo.account_name"
                      />
                    </div>
                    <!-- Subledger No -->
                    <div class="">
                      <label for="" class="form-label ">Subledger No</label>
                      <input
                        type="text"
                        class="form-control"
                        readonly
                        v-model="formOFItem.budgetInfo.subledger"
                      />
                    </div>
                    <!-- Subledger Name -->
                    <div class="">
                      <label for="" class="form-label ">Subledger Name</label>
                      <input
                        type="text"
                        class="form-control"
                        readonly
                        v-model="formOFItem.budgetInfo.subledger_name"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <!-- btn save and cancal -->
              <div class="mt-4 flex">
                <button
                  type="button"
                  class="btn btn-primary disabled:opacity-50 mr-2 flex items-center"
                  @click.prevent="saveItem()"
                  :disabled="btnItemSave.disabled"
                  v-show="!btnItemSave.hide"
                >
                  <FileTextIcon
                    class="w-4 h-4 mr-2"
                    v-if="!btnItemSave.loading"
                  />
                  <LoadingIcon
                    icon="oval"
                    color="blue"
                    v-else
                    class="w-4 h-4 mr-2"
                  />
                  Save
                </button>
                <button class="btn ml-2" @click="clearFormItem()">
                  <Trash2Icon class="w-4 h-4 mr-2" />Cancel
                </button>
              </div>

              <!-- modal table -->
              <div
                id="modal-budget"
                class="modal"
                tabindex="-1"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-xl">
                  <div class="modal-content">
                    <div class="modal-body p-10 text-center">
                      <TableBudget
                        v-model="formOFItem.budgetSelected"
                        @setBudget="setBudget"
                        :company="formOF.companySelected"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="modal-ledget"
                class="modal"
                tabindex="-1"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-xl">
                  <div class="modal-content">
                    <div class="modal-body p-10 text-center">
                      <TableSubledget
                        v-model="formOFItem.budgetSubledgerSelected"
                        @setSubledget="setBudget"
                        :company="formOF.companySelected"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="modal-material"
                class="modal"
                tabindex="-1"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-xl">
                  <div class="modal-content">
                    <div class="modal-body p-10 text-center">
                      <TableMaterialOF
                        v-model="formOFItem.materialSelected"
                        :materialGroup="orderTypeOptions"
                        :order-type="formOF.orderTypeSelected"
                        @setMaterial="setMaterial"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- รายการเบิก -->
          <div class="grid grid-cols-1 mt-5">
            <div class="box p-5">
              <div class="md:flex md:justify-between pb-4">
                <div class="flex">
                  <div class="text-lg font-bold">รายการสินค้า</div>
                  <OverBudget />
                </div>
                <div
                  class="col-span-2 flex flex-col gap-2 items-end mt-2 md:mt-0"
                >
                  <div class="flex flex-row items-center">
                    <div class="mr-2">
                      <span
                        >นำข้อมูลเข้าผ่าน
                        <a
                          :href="linkImportXlsx"
                          target="_blank"
                          class="text-theme-1 font-medium"
                          ><u>Excel template</u></a
                        ></span
                      >
                    </div>
                    <div class="flex flex-row">
                      <div class="w-6 h-6 mt-2 mr-2">
                        <LoadingIcon
                          icon="puff"
                          color="green"
                          v-show="importProcess"
                        />
                      </div>
                      <input
                        type="file"
                        ref="fileImport"
                        @change="importFile"
                        class="form-control w-56"
                      />
                    </div>
                  </div>
                  <div class="flex flex-row gap-2">
                    <button
                      class="btn bg-blue-300"
                      @click="toggleBoxItemOpen()"
                      v-if="
                        formOF.statusCode == 'OF_DRAFT' ||
                          formOF.statusCode === null
                      "
                    >
                      <PlusIcon
                        class="w-4 h-4 mr-2 hidden md:block"
                      />ระบุรายการสินค้า
                    </button>
                  </div>
                </div>
              </div>
              <!-- table -->
              <div class="overflow-x-scroll">
                <table class="table table--sm">
                  <thead>
                    <tr class="bg-gray-700 text-white">
                      <th class="whitespace-nowrap text-center" width="3%">
                        ลำดับ
                      </th>
                      <th class="whitespace-nowrap text-center" width="40%">
                        รายละเอียดสินค้า
                      </th>
                      <th class="whitespace-nowrap text-center" width="7%">
                        ราคาต่อหน่วย<br />(ไม่รวมภาษี)
                      </th>
                      <th class="whitespace-nowrap text-center" width="5%">
                        จำนวนสินค้า
                      </th>
                      <th class="whitespace-nowrap text-center" width="5%">
                        หน่วยนับ
                      </th>
                      <th class="whitespace-nowrap text-center" width="10%">
                        เงื่อนไขการจัดส่ง
                      </th>
                      <th class="whitespace-nowrap text-center" width="20%">
                        สถานที่จัดส่ง
                      </th>
                      <!-- <th class="whitespace-nowrap text-center" width="7%">
                        ราคา<br />ก่อนรวมภาษี
                      </th>
                      <th class="whitespace-nowrap text-center" width="7%">
                        ภาษี<br />มูลค่าเพิ่ม
                      </th>
                      <th class="whitespace-nowrap text-center" width="9%">
                        รวมเป็นเงิน<br />ทั้งหมด
                      </th> -->
                      <th class="whitespace-nowrap text-center" width="10%">
                        จัดการ
                      </th>
                      <!-- <th class="whitespace-nowrap">ภาษีมูลค่าเพิ่ม</th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="text-center" v-if="items.length == 0">
                      <td colspan="9" class="border-b">ไม่พบรายการ</td>
                    </tr>
                    <tr
                      v-for="(item, inx) in items"
                      :key="item.of_item_id"
                      v-else
                    >
                      <td class="border-b-2 text-center">{{ inx + 1 }}.</td>
                      <td class="border-b-2">
                        {{ item.name ? item.name.replaceAll('\n', '<br />') : ''
                        }}
                        <p
                          class="text-theme-6 font-bold"
                          v-show="item.isOverBudget"
                        >
                          *เกินงบประมาณ
                        </p>
                      </td>
                      <td class="text-right border-b-2">
                        {{ numberFormat(item.price) }}
                      </td>
                      <td class="text-right border-b-2">
                        {{ numberFormat(item.qty) }}
                      </td>
                      <td class="text-center border-b-2">{{ item.unit }}</td>
                      <td class="border-b-2">
                        {{ item.shipping_condition_send }}
                      </td>
                      <td class="border-b-2">{{ item.pickup_loc }}</td>
                      <!--
                      <td class="text-right border-b-2">
                        {{ numberFormat(item.amount) }}
                      </td>
                      <td class="text-right border-b-2">
                        {{ numberFormat(item.vat) }}
                      </td>
                      <td class="text-right border-b-2">
                        {{ numberFormat(item.actualCost) }}
                        <p
                          class="text-theme-6 font-bold"
                          v-show="item.isOverBudget"
                        >
                          *เกินงบประมาณ
                        </p>
                      </td>
                      -->
                      <td class="text-right border-b-2">
                        <div>
                          <button
                            class="btn btn-sm bg-white"
                            :class="[
                              item.is_edit
                                ? 'btn-warning'
                                : 'btn-outline-warning'
                            ]"
                            @click="getOFItem(item.of_item_id, inx)"
                          >
                            <EditIcon class="w-4 h-4" />
                          </button>
                          <a
                            href="javascript:;"
                            class="btn btn-sm btn-danger ml-2"
                            data-toggle="modal"
                            data-target="#delete-pv-item-modal-preview"
                            @click="setDeleteOFItem(item.of_item_id)"
                          >
                            <Trash2Icon class="w-4 h-4" />
                          </a>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- ประเภทของงบประมาณ -->
          <div class="grid lg:grid-cols-2 gap-0 lg:gap-4">
            <div class="mt-5">
              <TableSummaryCost :items="formOF.itemSummary" />
            </div>
            <div class="mt-5" v-if="formOF.ofEdit">
              <TableHistory :items="formOF.historyArray" />
            </div>
          </div>

          <!-- BEGIN: Modal Content -->
          <div
            id="delete-pv-item-modal-preview"
            class="modal"
            tabindex="-1"
            data-backdrop="static"
            aria-hidden="true"
          >
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-body p-0">
                  <div class="p-5 text-center">
                    <XCircleIcon class="w-16 h-16 text-theme-6 mx-auto mt-3" />
                    <div class="text-3xl mt-5">คุณแน่ใจ</div>
                    <div class="text-gray-600 mt-2">
                      ต้องการลบรายการนี้ ใช่ หรือ ไม่?
                    </div>
                  </div>
                  <div class="px-5 pb-8 text-center">
                    <button
                      type="button"
                      data-dismiss="modal"
                      class="btn btn-outline-secondary w-24 dark:border-dark-5 dark:text-gray-300 mr-1"
                      @click="cancelDeleteOFItem()"
                    >
                      ไม่
                    </button>
                    <button
                      type="button"
                      data-dismiss="modal"
                      class="btn btn-danger w-24"
                      @click="confirmDeleteOFItem()"
                    >
                      ใช่
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- END: Modal Content -->
          <!-- BEGIN: Modal Content -->
          <ModalCancel
            module="preorder"
            doc-type="of"
            :doc-id="formOF.ofID"
            redirect-complete="preorderOFList"
          />
          <!-- END: Modal Content -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  reactive,
  computed,
  onUnmounted,
  onMounted,
  ref,
  toRefs,
  watch
} from 'vue'
import { useStore } from '@/store'
import { useRoute, useRouter } from 'vue-router'
import { api, apiImportPreOrder } from '@/utils/api'
import { required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import alert from '@/helpers/alert'
import helpers from '@/helpers'

import OverBudget from '@/components/overBudget.vue'
import WfSelectSingleEmployee from '@/components/select-single-employee/Main.vue'
import TableBudget from '@/components/table-budget/Main.vue'
import TableMaterialOF from '@/components/table-material/OF.vue'
import TableSubledget from '@/components/table-subledget/Main.vue'
import TableSummaryCost from '@/components/TableSummaryCost.vue'
import TableHistory from '@/components/TableHistory.vue'
import AttachFileUpload from '@/components/attach-file/Upload.vue'
import WfSelectSingleVendor from '@/components/select-single-vendor/Main.vue'
import DocumentPath from '@/components/document-path/Main.vue'
import ModalCancel from '@/components/ModalCancel.vue'
import TextEditor from '@/components/TextEditor.vue'
import MemoAutoComplete from '@/components/MemoAutoComplete.vue'

export default {
  components: {
    OverBudget,
    WfSelectSingleEmployee,
    TableMaterialOF,
    TableBudget,
    TableSubledget,
    TableSummaryCost,
    AttachFileUpload,
    TableHistory,
    WfSelectSingleVendor,
    DocumentPath,
    ModalCancel,
    TextEditor,
    MemoAutoComplete
  },
  setup() {
    const store = useStore()
    const route = useRoute()
    const router = useRouter()
    const loadingPage = computed(() => store.state.global.loadingPage)
    const documentPath = computed(() => store.state.of.documentPath)
    const btnCancel = computed(() => store.state.of.btnCancel)
    const btnSave = computed(() => store.state.of.btnSave)
    const btnDraft = computed(() => store.state.of.btnDraft)
    const btnReject = computed(() => store.state.of.btnReject)
    const btnItemSave = computed(() => store.state.of.btnItemSave)
    const userInfo = computed(() => store.state.auth.info)

    const linkImportXlsx = ref(process.env.VUE_APP_IMPORT_OF_XLSX)
    const companyOptions = computed(() => store.state.global.company)
    const companyDefault = computed(() => store.state.global.companyDefault)
    const employeeDefault = computed(() => store.state.global.employeeDefault)
    const currencyOptions = computed(() => store.state.global.currency)
    const cashOptions = computed(() => store.state.global.cash)
    const memoOptions = computed(() => store.state.of.memo)
    const orderTypeOptions = computed(() => store.state.of.orderType)
    const paymentTermAllOptions = computed(() => store.state.of.paymentTermAll)
    const { numberFormat, numberFormat2, dateFormat, fillBorderColor } = helpers
    // const files = computed(() => store.state.of.files)
    const fileUploadMaxSize = computed(
      () => store.state.global.fileUploadMaxSize
    )
    const resValidator = ref(null)
    const shippingRecipientOption = computed(
      () => store.state.of.shippingRecipientOption
    )
    const isProjectBudgetEnable = ref(
      process.env.VUE_APP_PROJECT_BUDGET_ENABLE === 'true'
    )

    const uomCurrent = reactive({ label: null, value: null })
    const isEditItem = ref(false)

    const uomOptions = computed(() => store.getters['global/getUOMOptions'])
    // const documentSpacialPathOptions = computed(
    //   () => store.state.global.documentSpacialPath
    // )
    const documentPathText = computed(() => store.state.of.documentPathText)
    const formOF = reactive({
      ofID: route.params.id || null,
      isEdit: route.params.id || null,
      ofEdit: route.params.id !== undefined,
      companySelected: store.state.auth.info.comp_no,
      telephone: route.params.id
        ? null
        : store.state.global.employeeDefault.telephone,
      employeeSelected: store.state.auth.info.employeeId,
      currencySelected: store.state.global.currencyDefault,
      memoSelected: null,
      receiptNo: '',
      detail: '',
      orderTypeSelected: store.state.of.orderTypeDefault,
      itemSummary: [],
      historyArray: [],
      statusCode: null,

      // vendorSelected: null,
      // vendorCode: '',
      // vendorName: '',
      // vendorAddress: '',
      // vendorTelephone: '',
      // reasonChosenVendor: '',
      // poDocType: 'P',
      // notePurchaseDisplay: false,
      ofNo: '',
      ofRefInfo: {
        docNoFull: null,
        ofId: null
      },
      approveResultArray: [],
      documentPathArray: [],
      nextStatus: ''
      // shippingConditionSendSelected: null
    })

    const notYearBudget = reactive({
      isOverBudget: false,
      isOverBy: []
    })

    const rulesOF = {
      telephone: {
        required
      },
      currencySelected: { required },
      detail: { required }
    }

    const validateOF = useVuelidate(rulesOF, toRefs(formOF))

    watch(
      () => store.state.of.orderTypeDefault,
      () => {
        formOF.orderTypeSelected = store.state.of.orderTypeDefault
      }
    )

    // const specialPathSelected = ref(null)
    // watch(specialPathSelected, newVal => {
    //   store.dispatch('of/loadDocumentPath', {
    //     compNo: companyDefault.value.comp_no,
    //     employeeId: formOF.employeeSelected,
    //     specialPath: newVal
    //   })
    // })

    const items = ref([])
    const boxItemOpen = ref(false)
    const toggleBoxItemOpen = () => {
      clearFormItem()
      boxItemOpen.value = !boxItemOpen.value
    }

    const deleteOFItemID = ref(null)
    const setDeleteOFItem = id => {
      deleteOFItemID.value = id
    }
    const cancelDeleteOFItem = () => {
      deleteOFItemID.value = null
    }
    const confirmDeleteOFItem = async () => {
      const resDeleteOFItem = await api.delete(
        `preorder/of/deleteItem/${deleteOFItemID.value}`
      )
      if (resDeleteOFItem.code == 200) {
        alert.success('ลบรายการ สำเร็จ')
        const newItems = await items.value.filter(item => {
          return item.of_item_id != deleteOFItemID.value
        })
        items.value = newItems
        deleteOFItemID.value = null
      }
    }

    const selectedMemo = ref(null)

    const formOFItem = reactive({
      ofItemID: null,
      budgetSelected: null,
      materialSelected: null,
      budgetInfo: {
        year: '',
        bu_name: '',
        bu_code: '',
        bu_type: '',
        subledger: '',
        subsidiary: '',
        account_code: '',
        account_name: '',
        subledger_name: ''
      },
      budgetSubledgerSelected: null,
      bu_year: null,
      bu_name: null,
      uomSelected: null,
      paymentSelected: null,
      useDate: '',
      pickupLoc: '',
      amount: 0,
      vat: 0,
      qty: 0,
      // unitConversionPos: 0,
      actualCost: 0,
      taxVatDefault: 7,
      materialInfo: {
        account_code: null,
        all_unit: null,
        base_unit: null,
        business_unit_code: null,
        description: '',
        description_code: '',
        gl_category: '',
        it_item: null,
        material_code: '',
        material_group: '',
        material_type: '',
        plant: null,
        power_unit_no: null,
        price: null,
        purchase_group: null,
        primary_unit: '',
        secondary_unit: '',
        order_unit: '',
        stock_qty: 0,
        stock_text: '',
        stock_unit_name: '',
        storage_location: null,
        subsidiary: null,
        update_date: null
      },
      uomOption: [],
      vendorSelected: null,
      vendorName: null,
      vendorCode: null,
      vendorAddress: null,
      vendorTelephone: null,
      shippingConditionSendSelected: null
    })

    const summaryAmount = () => {
      if (formOFItem.materialInfo.price > 0 && formOFItem.qty > 0) {
        formOFItem.amount = parseFloat(
          numberFormat2(formOFItem.materialInfo.price * formOFItem.qty)
        )
      } else {
        formOFItem.amount = 0
      }
      summaryActualCost()
    }

    const summaryActualCost = () => {
      // console.log('change price')
      // if (formOFItem.materialInfo.price > 0 && formOFItem.qty > 0) {
      //   formOFItem.amount = formOFItem.materialInfo.price * formOFItem.qty
      //   formOFItem.vat = parseFloat(
      //     numberFormat2((formOFItem.amount * formOFItem.taxVatDefault) / 100)
      //   )
      //   formOFItem.actualCost = numberFormat2(
      //     formOFItem.vat + formOFItem.amount
      //   )
      // }
      // if (formOFItem.materialInfo.price > 0 && formOFItem.qty > 0) {
      // formOFItem.amount = formOFItem.materialInfo.price * formOFItem.qty
      formOFItem.vat = parseFloat(
        numberFormat2((formOFItem.amount * formOFItem.taxVatDefault) / 100)
      )
      formOFItem.actualCost = numberFormat2(formOFItem.vat + formOFItem.amount)
      // }
    }

    // watch vat item actual cost
    // watch(
    //   [
    //     () => formOFItem.materialInfo.price,
    //     () => formOFItem.qty
    //     // () => formOFItem.taxVatDefault
    //   ],
    //   () => {
    //     summaryActualCost()
    //   }
    // )

    const rulesItem = {
      materialInfo: {
        description: { required },
        price: { required }
      },
      budgetInfo: {
        year: { required },
        bu_name: { required },
        bu_code: { required },
        bu_type: { required }
      },
      amount: { required },
      pickupLoc: { required },
      qty: { required },
      // unitConversionPos: {
      //   requiredIf: value => value > 0
      // },
      uomSelected: { required },
      paymentSelected: { required },
      useDate: { required },
      actualCost: { required },
      vendorSelected: { required }
    }

    const validateItem = useVuelidate(rulesItem, toRefs(formOFItem))
    // console.log('validateItem: ', validateItem)

    const setBudget = val => {
      formOFItem.budgetInfo.year = val.year
      formOFItem.budgetInfo.bu_code = val.bu_code
      formOFItem.budgetInfo.bu_name = val.bu_name
      formOFItem.budgetInfo.subsidiary = val.subsidiary
      formOFItem.budgetInfo.subledger = val.subledger
      formOFItem.budgetInfo.account_code = val.account_code
      formOFItem.budgetInfo.account_name = val.account_name
      formOFItem.budgetInfo.subledger_name = val.subledger_name
      formOFItem.budgetInfo.bu_type = val.subledger
        ? 'งบประมาณโครงการ'
        : 'งบประมาณหน่วยงาน'
    }

    const materialDesOld = ref(null)
    const setMaterial = val => {
      formOFItem.materialInfo.account_code = val.account_code
      formOFItem.materialInfo.all_unit = val.all_unit
      formOFItem.materialInfo.base_unit = val.base_unit
      formOFItem.materialInfo.business_unit_code = val.business_unit_code
      formOFItem.materialInfo.description = val.description
      formOFItem.materialInfo.description_code = val.description_code
      formOFItem.materialInfo.gl_category = val.gl_category
      formOFItem.materialInfo.it_item = val.it_item
      formOFItem.materialInfo.material_code = val.material_code
      formOFItem.materialInfo.material_group = val.material_group
      formOFItem.materialInfo.material_type = val.material_type
      formOFItem.materialInfo.order_unit = val.order_unit
      formOFItem.materialInfo.plant = val.plant
      formOFItem.materialInfo.power_unit_no = val.power_unit_no
      formOFItem.materialInfo.secondary_unit = val.secondary_unit
      formOFItem.materialInfo.storage_location = val.storage_location
      formOFItem.materialInfo.subsidiary = val.subsidiary
      formOFItem.materialInfo.update_date = val.update_date
      formOFItem.materialInfo.primary_unit = val.primary_unit
      formOFItem.materialInfo.purchase_group = val.purchase_group
      formOFItem.materialInfo.price = val.price ? val.price : 0
      formOFItem.materialInfo.stock_qty = val.stock_qty ? val.stock_qty : 0
      formOFItem.materialInfo.stock_text = val.stock_qty_text
      formOFItem.materialInfo.stock_unit_name = val.stock_unit_name
      // formOFItem.unitConversionPos = val.unit_conversion_pos
      materialDesOld.value = val.description

      formOFItem.uomSelected = val.order_unit
        ? val.order_unit.trim()
        : val.order_unit
      if (val.purchase_group) {
        if (
          val.purchase_group.toUpperCase() == 'NON-VAT' ||
          val.purchase_group.toUpperCase() == 'NON VAT' ||
          val.purchase_group.toUpperCase() == 'N-VAT'
        ) {
          formOFItem.taxVatDefault = 0
        }
      } else {
        formOFItem.taxVatDefault = 7
      }
    }

    watch(
      () => formOFItem.vendorSelected,
      newVal => {
        if (newVal) {
          formOFItem.vendorName = newVal.vendor_name
          formOFItem.vendorCode = newVal.vendor_code
          formOFItem.vendorAddress = newVal.vendor_address
          formOFItem.vendorTelephone = newVal.phone_no

          if (formOFItem.paymentSelected == null) {
            formOFItem.paymentSelected = paymentTermAllOptions.value.find(
              r => r.code == newVal.payment_term_code
            )
          }
        }
      }
    )

    // watch([companyDefault, () => formOF.employeeSelected], (newVal, oldVal) => {
    //   if (newVal[0] != oldVal[0]) {
    //     store.dispatch('global/loadDocumentSpacialPath', {
    //       compNo: companyDefault.value.comp_no
    //     })
    //     store.dispatch('of/loadDocumentPath', {
    //       compNo: companyDefault.value.comp_no,
    //       employeeId: formOF.employeeSelected,
    //       specialPath: specialPathSelected.value
    //     })
    //     store.dispatch('of/loadOrderType', {
    //       compNo: companyDefault.value.comp_no,
    //       employeeId: newVal[1]
    //     })
    //   }

    //   // console.log(lockField.status, formOF.ofEdit, specialPathSelected.value)
    //   if (!lockField.status) {
    //     specialPathSelected.value = null
    //   }

    //   if (newVal[1] != oldVal[1]) {
    //     store.dispatch('of/loadDocumentPath', {
    //       compNo: companyDefault.value.comp_no,
    //       employeeId: formOF.employeeSelected,
    //       specialPath: null
    //     })
    //   }
    // })

    const onChangeDocumentPath = async data => {
      if (data.target == 'select-company') {
        store.commit('global/setCompanyDefault', { no: formOF.companySelected })
        store.dispatch('of/loadOrderType', {
          compNo: companyDefault.value.comp_no,
          employeeId: formOF.employeeSelected
        })
      }
      // if (
      //   data.target == 'select-single-employee' ||
      //   data.target == 'select-company'
      // ) {
      //   // loading special path option
      //   await store.dispatch('global/loadDocumentSpacialPath', {
      //     compNo: companyDefault.value.comp_no
      //   })
      //   specialPathSelected.value = null
      // }
      await store.dispatch('of/loadDocumentPath', {
        // compNo: companyDefault.value.comp_no,
        compNo: formOF.companySelected,
        employeeId: formOF.employeeSelected
        // specialPath: specialPathSelected.value
      })
      store.dispatch('of/loadShippingRecipientList', {
        compNo: companyDefault.value.comp_no
      })
      formOFItem.shippingConditionSendSelected = null
    }

    watch(
      () => employeeDefault.value,
      newVal => {
        if (!formOF.ofEdit && formOF.ofNo == '') {
          formOF.telephone = newVal.telephone
        }
      }
    )

    const saveOF = async isDraft => {
      // disabled and loading
      validateOF.value.$touch()
      if (validateOF.value.$invalid) {
        alert.error()
        return false
      }
      validateOF.value.$reset()
      if (isDraft) {
        store.commit('of/setBtnActiveFix', { type: 'btnDraft', status: true })
      } else {
        store.commit('of/setBtnActiveFix', { type: 'btnSave', status: true })
      }

      const dataOF = {
        is_draft: isDraft,
        username: userInfo.value.username,
        employee_id: userInfo.value.employeeId,
        of_comp: formOF.companySelected,
        // special_path: specialPathSelected.value,
        document_path: documentPath.value, // สายอนุมัติของเปิดเอกสาร

        ememo_id: formOF.memoSelected,
        ememo_title: '',
        order_type: formOF.orderTypeSelected,

        req_id: employeeDefault.value.employee_id, // '620071', // ? ผู้ขอเบิก
        req_name: employeeDefault.value.fullname_th, // 'ธนัชกฤศ เกตุนะ', // ? ชื่อผู้ขอเบิก
        req_detail: fillBorderColor(formOF.detail), // ?
        // payee_no: employeeDefault.value.employee_id, // '620071', // ?
        // payee_name: employeeDefault.value.fullname_th, // 'ธนัชกฤศ เกตุนะ', // ?

        owner_id: userInfo.value.employeeId, // ผู้ขอเบิก
        owner_name: userInfo.value.fullname, // ชื่อผู้ขอเบิก
        bu_no: employeeDefault.value.bu_no, // รหัสหน่วยงาน
        bu_name: employeeDefault.value.bu_name, // ชื่อหน่วยงาน
        telephone: formOF.telephone, // เบอร์ติดต่อ
        file_attach: await store.getters['of/getFileAttach'], // เอกสารแนบ
        currency_code: formOF.currencySelected // สกุลเงิน
      }

      // if (formOF.notePurchaseDisplay) {
      //   dataOF.vendor_code = formOF.vendorCode
      //   dataOF.vendor_name = formOF.vendorName
      //   dataOF.vendor_address = formOF.vendorAddress
      //   dataOF.vendor_telephone = formOF.vendorTelephone
      //   dataOF.po_doc_type = formOF.poDocType
      //   dataOF.reason_chosen_vendor = formOF.reasonChosenVendor
      // }

      // if (formOF.memoSelected) {
      //   const memo = memoOptions.value.find(item => {
      //     return item.id == formOF.memoSelected
      //   })
      //   if (memo) {
      //     dataOF.ememo_title = memo.doc_no + ' - ' + memo.title
      //   }
      // }
      if (selectedMemo.value) {
        dataOF.ememo_id = selectedMemo.value.id
        dataOF.ememo_title = `${selectedMemo.value.doc_no_full} - ${selectedMemo.value.title}`
      }

      // if (formOF.vendorSelected) {
      //   dataOF.vendor_no = formOF.vendorNo
      //   dataOF.vendor_name = formOF.vendorName
      // }

      resValidator.value = null
      if (!formOF.ofEdit) {
        await api
          .post('/preorder/of/insert', dataOF)
          .then(res => {
            if (res.code == 200) {
              formOF.ofID = res.data.of_id
              formOF.ofEdit = true
              alertBudget(false, res.data.is_over_budget)
              alert.success()
              store.commit('of/setBtn', { type: 'btnCancel', value: 'hide' })
            } else {
              resValidator.value = res.validator
              store.commit('of/setBtnActiveFix', {
                type: 'btnDraft',
                status: false
              })
              store.commit('of/setBtnActiveFix', {
                type: 'btnSave',
                status: false
              })

              if (res.validator) {
                alert.validatorShow(res.validator)
              } else {
                alert.error(res.message)
              }
              return
            }
            if (isDraft) {
              store.commit('of/setBtnActiveFix', {
                type: 'btnDraft',
                status: false
              })
            } else {
              router.push({
                name: 'preorderOFFormDetail',
                params: { id: res.data.of_id }
              })
            }
          })
          .catch(e => {
            alert.error(e.message)
            if (isDraft) {
              store.commit('of/setBtnActiveFix', {
                type: 'btnDraft',
                status: false
              })
            } else {
              store.commit('of/setBtnActiveFix', {
                type: 'btnSave',
                status: false
              })
            }
          })
      } else {
        await api
          .put(`/preorder/of/update/${formOF.ofID}`, dataOF)
          .then(res => {
            if (res.code == 200) {
              alertBudget(false, res.data.is_over_budget)
              alert.success()
            } else {
              store.commit('of/setBtnActiveFix', {
                type: 'btnDraft',
                status: false
              })
              store.commit('of/setBtnActiveFix', {
                type: 'btnSave',
                status: false
              })
              // check item over old budget year
              // console.log('res: ', items.value)
              notYearBudget.isOverBudget = res.data.is_not_year_budget
              notYearBudget.isOverBy = res.data.is_not_year_by
              // setTimeout(() => {
              handleOverYearBudget()
              // }, 500)
              if (res.validator) {
                alert.validatorShow(res.validator)
              } else {
                alert.error(res.message)
              }
              return
            }
            if (isDraft) {
              store.commit('of/setBtnActiveFix', {
                type: 'btnDraft',
                status: false
              })
            } else {
              // if (formOF.notePurchaseDisplay) {
              //   store.commit('of/setBtnActiveFix', {
              //     type: 'btnSave',
              //     status: false
              //   })
              // } else {
              router.push({
                name: 'preorderOFFormDetail',
                params: { id: formOF.ofID }
              })
              // }
            }
          })
          .catch(e => {
            alert.error(e.message)
            if (isDraft) {
              store.commit('of/setBtnActiveFix', {
                type: 'btnDraft',
                status: false
              })
            } else {
              store.commit('of/setBtnActiveFix', {
                type: 'btnSave',
                status: false
              })
            }
          })
      }
    }

    const handleOverYearBudget = () => {
      if (notYearBudget.isOverBudget) {
        for (const i in notYearBudget.isOverBy) {
          items.value.map(v => {
            if (v.of_item_id == notYearBudget.isOverBy[i]) {
              v.isOverBudget = true
            }
          })
        }
      }
    }

    const clearFormItem = () => {
      validateItem.value.$reset()
      isEditItem.value = false
      boxItemOpen.value = false
      if (formOFItem.ofItemID !== null) {
        for (const i in items.value) {
          items.value[i].is_edit = false
        }
      }
      formOFItem.ofItemID = null
      formOFItem.budgetSelected = null
      formOFItem.materialSelected = null
      formOFItem.isItselfTax = false

      formOFItem.budgetInfo = {
        year: '',
        bu_name: '',
        bu_code: '',
        bu_type: '',
        subledger: '',
        subsidiary: '',
        account_code: '',
        account_name: '',
        subledger_name: ''
      }
      formOFItem.useDate = ''
      formOFItem.pickupLoc = ''
      formOFItem.uomSelected = null
      formOFItem.paymentSelected = null
      formOFItem.budgetSubledgerSelected = null
      formOFItem.bu_year = null
      formOFItem.bu_name = null
      formOFItem.detail = null
      formOFItem.amount = 0
      formOFItem.vat = 0
      formOFItem.qty = 0
      // formOFItem.unitConversionPos = 0
      formOFItem.actualCost = 0
      formOFItem.taxVatDefault = 7
      formOFItem.materialInfo = {
        account_code: null,
        all_unit: null,
        base_unit: null,
        business_unit_code: null,
        description: '',
        description_code: '',
        gl_category: '',
        it_item: null,
        material_code: '',
        material_group: '',
        material_type: '',
        order_unit: '',
        plant: null,
        power_unit_no: null,
        price: null,
        primary_unit: '',
        purchase_group: null,
        secondary_unit: '',
        storage_location: null,
        subsidiary: null,
        update_date: null
      }
      formOFItem.vendorSelected = null
      formOFItem.vendorName = null
      formOFItem.vendorCode = null
      formOFItem.vendorAddress = null
      formOFItem.vendorTelephone = null
      formOFItem.shippingConditionSendSelected = null
    }

    const saveItem = async () => {
      validateItem.value.$touch()
      if (!validateItem.value.$invalid) {
        // console.log('validateItem: ', validateItem)
        store.commit('of/setBtnActiveFix', {
          type: 'btnItemSave',
          status: true
        })
        if (formOF.ofID === null) {
          await saveOF(true)
        }

        // const uom = uomOptions.find(item => item.value == formOFItem.uomSelected)
        const uom = await store.getters['global/getUOMbyOne'](
          formOFItem.uomSelected
        )

        const dataItem = {
          of_id: formOF.ofID,
          item_category: formOFItem.materialInfo.material_group,
          item_type: formOFItem.materialInfo.material_type,
          item_no: formOFItem.materialInfo.material_code,
          item_code: formOFItem.materialInfo.description_code,
          item_name: formOFItem.materialInfo.description,
          uom: uom.uom_name,
          uom_code: uom.uom_code,
          // uom: uom.label,
          // uom_code: formOFItem.uomSelected,

          unit_price: formOFItem.materialInfo.price,
          item_stock_qty: formOFItem.materialInfo.stock_text,
          item_stock_qty_pos: formOFItem.materialInfo.stock_qty,
          item_stock_unit_pos: formOFItem.materialInfo.stock_unit_name,

          vat_rate: formOFItem.taxVatDefault,
          qty: formOFItem.qty,
          // unit_conversion_pos: formOFItem.unitConversionPos,
          use_date: dateFormat(formOFItem.useDate),
          pickup_loc: formOFItem.pickupLoc,

          budget_year: formOFItem.budgetInfo.year,
          budget_type: formOFItem.budgetInfo.subledger ? null : 'bu',
          budget_bu_code: formOFItem.budgetInfo.bu_code,
          budget_bu_name: formOFItem.budgetInfo.bu_name,
          budget_bu_req_code: formOFItem.budgetInfo.bu_code,
          budget_bu_req_name: formOFItem.budgetInfo.bu_name,
          budget_code: formOFItem.budgetInfo.account_code,
          budget_name: formOFItem.budgetInfo.account_name,

          vendor_name: formOFItem.vendorName,
          vendor_code: formOFItem.vendorCode,
          vendor_address: formOFItem.vendorAddress,
          vendor_telephone: formOFItem.vendorTelephone,

          shipping_condition_send: formOFItem.shippingConditionSendSelected,

          payment_term_code: formOFItem.paymentSelected
            ? formOFItem.paymentSelected.code
            : '',
          payment_term_name: formOFItem.paymentSelected
            ? formOFItem.paymentSelected.name
            : '',

          budget_subsidiary:
            formOFItem.budgetInfo.subledger !== ''
              ? formOFItem.budgetInfo.subsidiary
              : null,
          budget_subledger:
            formOFItem.budgetInfo.subledger !== ''
              ? formOFItem.budgetInfo.subledger
              : null,
          budget_subledger_name:
            formOFItem.budgetInfo.subledger !== ''
              ? formOFItem.budgetInfo.subledger_name
              : null,

          amount: formOFItem.amount,
          vat: formOFItem.vat,
          actual_cost: formOFItem.actualCost
        }

        const popNotYearBudget = notYearBudget.isOverBy.filter(
          v => v != formOFItem.ofItemID
        )
        notYearBudget.isOverBy = popNotYearBudget
        if (popNotYearBudget.length == 0) {
          notYearBudget.isOverBudget = false
        }

        if (formOFItem.ofItemID === null) {
          await api
            .post('/preorder/of/insertItem', dataItem)
            .then(async res => {
              if (res.code == 200) {
                items.value.push(res.data)
                clearFormItem()
                await reloadOF()
              } else {
                if (res.validator) {
                  alert.validatorShow(res.validator)
                } else {
                  alert.error(res.message)
                }
              }
            })
            .catch(e => {
              alert.error(e.message)
              store.commit('of/setBtnActiveFix', {
                type: 'btnItemSave',
                status: false
              })
            })
        } else {
          await api
            .put(`/preorder/of/updateItem/${formOFItem.ofItemID}`, dataItem)
            .then(async res => {
              if (res.code == 200) {
                clearFormItem()
                await reloadOF()
              } else {
                if (res.validator) {
                  alert.validatorShow(res.validator)
                } else {
                  alert.error(res.message)
                }
              }
            })
            .catch(e => {
              store.commit('of/setBtnActiveFix', {
                type: 'btnItemSave',
                status: false
              })
            })
        }
        // reloadOF()
        store.commit('of/setBtnActiveFix', {
          type: 'btnItemSave',
          status: false
        })
        return dataItem
      } else {
        alert.error()
      }
    }

    const alertBudget = (isLoading, isOver) => {
      if (isLoading) {
        store.commit('global/setOverBudget', {
          message: 'กำลังตรวจสอบ',
          isOver: true,
          show: true
        })
      } else {
        store.commit('global/setOverBudget', {
          message: isOver == 1 ? 'เกินงบประมาณ' : 'อยู่ในงบประมาณ',
          isOver: isOver == 1,
          show: true
        })
      }
    }

    const setItems = data => {
      items.value = data.map(item => {
        return {
          of_item_id: item.of_item_id,
          pickup_loc: item.pickup_loc,
          shipping_condition_send: item.shipping_condition_send,
          name: item.item_name,
          price: item.unit_price,
          qty: item.qty,
          unit_conversion_pos: item.unit_conversion_pos,
          unit: item.uom,
          amount: item.amount,
          vat: item.vat,
          actualCost: item.actual_cost,
          is_edit: false,
          isOverBudget: false
        }
      })
    }

    const reloadOF = async () => {
      if (formOF.ofID) {
        await api
          .get(
            `${process.env.VUE_APP_API_URL}/preorder/of/getByOfId/${formOF.ofID}`
          )
          .then(res => {
            if (res.code == 200) {
              setItems(res.data.items)
              handleOverYearBudget()
              formOF.itemSummary = res.data.itemSummary
              console.log('reload OF success')
            }
          })
          .catch(e => {
            alert.error(e.message)
          })
      }
    }

    onUnmounted(() => {
      console.log('unmounted page of form')
      store.commit('global/setLoadingPage', true)
      store.commit('of/initBtn')
    })

    const lockField = reactive({
      status: false,
      label: '(ไม่สามารถแก้ไขได้)'
    })

    const getOF = async () => {
      if (route.params.id) {
        await api
          .get(
            `${process.env.VUE_APP_API_URL}/preorder/of/getByOfId/${route.params.id}`
          )
          .then(res => {
            if (res.code == 200) {
              formOF.companySelected = res.data.of_comp
              formOF.employeeSelected = res.data.req_id
              formOF.currencySelected = res.data.currency_code
              formOF.telephone = res.data.telephone
              formOF.detail = res.data.req_detail
              // specialPathSelected.value = res.data.special_path
              formOF.itemSummary = res.data.itemSummary
              formOF.historyArray = res.data.history_array
              formOF.statusCode = res.data.status_code
              formOF.ofNo = res.data.doc_no_full
              // formOF.notePurchaseDisplay =
              //   res.data.is_permission_purchase == '1'

              // if (formOF.notePurchaseDisplay) {
              //   tmpVendor.code = res.data.vendor_code
              //   tmpVendor.name = res.data.vendor_name
              //   tmpVendor.address = res.data.vendor_address
              //   tmpVendor.telephone = res.data.vendor_telephone

              //   formOF.vendorSelected =
              //     res.data.vendor_code != null
              //       ? res.data.vendor_code.toString()
              //       : null
              //   formOF.vendorCode = res.data.vendor_code
              //   formOF.vendorName = res.data.vendor_name
              //   formOF.vendorAddress = res.data.vendor_address
              //   formOF.vendorTelephone = res.data.vendor_telephone
              //   formOF.poDocType =
              //     res.data.po_doc_type != '' ? res.data.po_doc_type : 'P'
              //   formOF.reasonChosenVendor = res.data.reason_chosen_vendor
              // }

              formOF.approveResultArray = res.data.approve_result_array
              formOF.documentPathArray = res.data.document_path_array
              formOF.nextStatus = res.data.next_status

              if (res.data.doc_no_full != '') {
                lockField.status = true
              }

              // console.log('load get pv')
              store.commit(
                'of/setDocumentPathText',
                res.data.document_path_text_array
              )
              store.commit('of/setDocumentPath', res.data.document_path_array)
              for (const i in res.data.file_attach_array) {
                store.commit('of/setFile', res.data.file_attach_array[i])
              }

              // store.dispatch('global/loadDocumentSpacialPath', {
              //   compNo: res.data.of_comp
              // })

              if (res.data.ememo_id) {
                formOF.memoSelected = res.data.ememo_id
              }
              setItems(res.data.items)

              store.commit('of/setBtn', { type: 'btnCancel', value: 'hide' })
              if (res.data.status_code != 'OF_DRAFT') {
                store.commit('of/setBtn', { type: 'btnDraft', value: 'hide' })
                // if (res.data.flag_edit === null || res.data.flag_edit === 0) {
                //   store.commit('of/setBtn', { type: 'btnSave', value: 'hide' })
                // }
                // if (res.data.is_permission_purchase == 1) {
                // store.commit('prsetBtn', { type: 'btnSave', value: 'hide' })
                // }
              }

              if (res.data.of_ref_info) {
                formOF.ofRefInfo.docNoFull = res.data.of_ref_info.doc_no_full
                formOF.ofRefInfo.ofId = res.data.of_ref_info.of_id
              }

              if (
                res.data.is_editing != 1 &&
                res.data.status_code == 'CMD_REVIEW'
              ) {
                store.commit('of/setBtn', { type: 'btnReject', value: 'hide' })
              }
            }
          })
          .catch(e => {
            alert.error(e.message)
          })
      }
      // await store.commit('global/setLoadingPage', false)
      return true
    }

    const getMaterialByOne = async materialCode => {
      await api
        .get(
          `${process.env.VUE_APP_API_URL}/preorder/materials/getByMaterialCode/${materialCode}`
        )
        .then(res => {
          // console.log('get material by code: ', res)
          if (res.code == 200) {
            formOFItem.materialInfo.stock_qty = res.data.stock_qty
            // formOFItem.materialInfo.stock_text = res.data.stock_unit_name
          }
        })
        .catch(e => {
          alert.error(e.message)
        })
      // return await store.getters['global/getMaterialOne'](materialCode)
    }

    const getOFItem = async (ofItemID, index) => {
      isEditItem.value = true
      for (const i in items.value) {
        items.value[i].is_edit = false
      }
      items.value[index].is_edit = true
      await api
        .get(
          `${process.env.VUE_APP_API_URL}/preorder/of/getItemById/${ofItemID}`
        )
        .then(res => {
          if (res.code == 200) {
            boxItemOpen.value = true

            formOFItem.ofItemID = res.data.of_item_id
            formOFItem.budgetInfo = {
              year: res.data.budget_year,
              bu_name: res.data.budget_bu_name,
              bu_code: res.data.budget_bu_code,
              bu_type: res.data.budget_subledger
                ? 'งบประมาณโครงการ'
                : 'งบประมาณหน่วยงาน',
              subledger: res.data.budget_subledger,
              subsidiary: res.data.budget_subsidiary,
              account_code: res.data.budget_code,
              account_name: res.data.budget_name,
              subledger_name: res.data.budget_subledger_name
            }
            formOFItem.bu_year = res.data.budget_year
            formOFItem.bu_name = res.data.budget_name
            formOFItem.uomSelected = res.data.uom_code
            formOFItem.useDate = res.data.use_date
            formOFItem.pickupLoc = res.data.pickup_loc
            formOFItem.amount = res.data.amount
            formOFItem.vat = numberFormat2(res.data.vat)
            formOFItem.qty = res.data.qty
            formOFItem.actualCost = numberFormat2(res.data.actual_cost)
            formOFItem.taxVatDefault = res.data.vat_rate
            formOFItem.shippingConditionSendSelected =
              res.data.shipping_condition_send

            formOFItem.paymentSelected = paymentTermAllOptions.value.find(
              r => r.name == res.data.payment_term_name
            )

            formOFItem.materialInfo.material_group = res.data.item_category
            formOFItem.materialInfo.material_code = res.data.item_no
            formOFItem.materialInfo.description = res.data.item_name
            formOFItem.materialInfo.description_code = res.data.item_code
            formOFItem.materialInfo.material_type = res.data.item_type
            formOFItem.materialInfo.price = numberFormat2(res.data.unit_price)
            formOFItem.materialInfo.stock_qty = res.data.item_stock_qty_pos
            formOFItem.materialInfo.stock_text = res.data.item_stock_qty_text
            // formOFItem.unitConversionPos = res.data.unit_conversion_pos
            formOFItem.materialInfo.stock_unit_name =
              res.data.item_stock_unit_pos

            formOFItem.vendorSelected =
              res.data.vendor_code != null
                ? res.data.vendor_code.toString()
                : null

            materialDesOld.value = res.data.item_name

            // console.log('get item of against of: ', res.data)
            getMaterialByOne(res.data.item_no)
          }
        })
        .catch(e => {
          alert.error(e.message)
        })
      return true
    }

    const rejectOF = async () => {
      store.commit('of/setBtnActive', { type: 'btnReject' })
      await api
        .put(
          `${process.env.VUE_APP_API_URL}/preorder/of/editBeforeApprove/${formOF.ofID}`
        )
        .then(res => {
          if (res.code == 200) {
            store.commit('of/setBtn', { type: 'btnDraft', value: 'hide' })
            store.commit('of/setBtn', { type: 'btnSave', value: 'hide' })
            store.commit('of/setBtn', { type: 'btnReject', value: 'hide' })
            store.commit('of/setBtnActive', { type: 'btnReject' })
          } else {
            alert.error(res.message)
          }
        })
    }

    const calVat = () => {
      formOFItem.actualCost = numberFormat2(formOFItem.vat + formOFItem.amount)
    }

    const calVatRate = () => {
      formOFItem.vat = parseFloat(
        numberFormat2((formOFItem.taxVatDefault * formOFItem.amount) / 100)
      )
      calVat()
    }

    // const updateMaterialVendor = async () => {
    //   // console.log(
    //   //   'updateMaterialVendor: ',
    //   //   formOFItem.vendorSelected,
    //   //   formOFItem.materialInfo.description_code
    //   // )
    //   if (
    //     formOFItem.vendorSelected != null &&
    //     (formOFItem.materialInfo.description_code != null ||
    //       formOFItem.materialInfo.description_code != '')
    //   ) {
    //     await api
    //       .post(`${process.env.VUE_APP_API_URL}/preorder/materialVendor/save`, {
    //         material_code: formOFItem.materialInfo.description_code,
    //         vendor_code: formOFItem.vendorSelected.vendor_code, // 11VEN-00037 , 11Tast-1
    //         description: formOFItem.materialInfo.description
    //       })
    //       .then(res => {
    //         console.log('save material vendor res: ', res)
    //       })
    //   }
    // }

    watch(
      [
        () => formOFItem.vendorSelected,
        () => formOFItem.materialInfo.description_code
      ],
      async (newVal, oldVal) => {
        if (newVal[0] != null && (newVal[1] != null || newVal[1] != '')) {
          // console.log('watch material: ', newVal, oldVal)
          const newMaterialVendor = await store.dispatch(
            'of/getMaterialVendor',
            {
              vendorCode: newVal[0].vendor_code,
              materialCode: newVal[1]
            }
          )
          if (newMaterialVendor) {
            formOFItem.materialInfo.description = newMaterialVendor.description
          } else {
            formOFItem.materialInfo.description = materialDesOld.value
          }
          // console.log('newMaterialVendor: ', newMaterialVendor)
        }
      }
    )

    watch(
      () => formOFItem.shippingConditionSendSelected,
      (newVal, oldVal) => {
        if (newVal) {
          const t = shippingRecipientOption.value.find(
            item => item.value == newVal
          )
          if (t) {
            if (t.address) {
              if (isEditItem.value) {
                if (oldVal != null) {
                  formOFItem.pickupLoc = t.address
                }
              } else {
                formOFItem.pickupLoc = t.address
              }
            }
          }
        }
      }
    )

    watch(
      () => formOFItem.uomSelected,
      newVal => {
        const uom = uomOptions.value.find(v => v.value == newVal)
        if (uom) {
          uomCurrent.label = uom.label
          uomCurrent.value = uom.value
        }
      }
    )

    const importProcess = ref(false)
    const importFile = async event => {
      if (formOF.ofID === null) {
        await saveOF(true)
      }
      if (event.target.files[0]) {
        if (event.target.files[0].name.length <= 200) {
          if (formOF.ofID !== null) {
            importProcess.value = true
            const formData = new FormData()
            formData.append('file', event.target.files[0])
            formData.append('doc_type', 'of')
            formData.append('doc_id', formOF.ofID)
            await apiImportPreOrder
              .post('/import/docItem', formData)
              .then(res => {
                // console.log('res: ', res, res.data.insert_fail)
                importProcess.value = false
                if (res.data.insert_fail > 0) {
                  const errorMsg = res.data.insert_fail_data.map(item => {
                    return `บรรทัดที่ ${item.line_fail}. ${item.message}`
                  })
                  alert.error(errorMsg.join('<br>') + '<br>กรุณาตรวจสอบ')
                  event.target.value = null
                } else {
                  alert.success()
                  reloadOF()
                }
              })
              .catch(e => {
                alert.error(e.message)
                importProcess.value = false
              })
          } else {
            event.target.value = null
          }
        } else {
          alert.error('ชื่อไฟล์ยาวเกิน 200 ตัวอักษร')
        }
      }
    }

    onMounted(async () => {
      console.log('mounted page of form')
      await store.dispatch('global/loadCompany')
      store.dispatch('global/loadCurrency')
      store.dispatch('global/loadCash')
      store.dispatch('global/loadFileUploadMaxSize')
      store.commit('global/resetOverBudget')
      store.dispatch('of/loadMaterialFilterOption')
      store.dispatch('global/loadUOM')
      store.dispatch('of/loadPaymentTerm')
      await store.dispatch('global/loadEmployee')

      // if (!formOF.ofEdit) {
      //   await store.dispatch('global/loadDocumentSpacialPath', {
      //     compNo: store.state.auth.info.comp_no
      //   })
      // }

      store.commit('of/setBtn', { type: 'btnItemSave', value: 'hide' })
      store.commit('of/setBtn', { type: 'btnSave', value: 'hide' })
      store.commit('of/setBtn', { type: 'btnDraft', value: 'hide' })
      // console.log('mounted: ', companyDefault)
      await getOF()
      // await store.dispatch('of/loadDocumentPath', {
      //   compNo: companyDefault.value.comp_no,
      //   employeeId: formOF.employeeSelected,
      //   specialPath: null
      // })
      await store.dispatch('of/loadEmployeeById', {
        employeId: formOF.employeeSelected
      })
      store.dispatch('of/loadMemo', { ememoId: formOF.memoSelected })
      store.commit('global/setCompanyDefault', { no: formOF.companySelected })
      await store.dispatch('of/loadOrderType', {
        compNo: store.state.auth.info.comp_no,
        employeeId: formOF.employeeSelected
      })
      // companyChange()
      await onChangeDocumentPath({ target: 'mounted' })
      await store.commit('global/setLoadingPage', false)

      // formOF.vendorCode = tmpVendor.code
      // formOF.vendorName = tmpVendor.name
      // formOF.vendorAddress = tmpVendor.address
      // formOF.vendorTelephone = tmpVendor.telephone
    })

    return {
      loadingPage,
      btnSave,
      btnCancel,
      btnDraft,
      btnReject,
      btnItemSave,
      boxItemOpen,
      toggleBoxItemOpen,
      companyDefault,
      companyOptions,
      orderTypeOptions,
      clearFormItem,
      currencyOptions,
      cashOptions,
      // documentSpacialPathOptions,
      // specialPathSelected,
      memoOptions,
      fileUploadMaxSize,
      formOF,
      formOFItem,
      getOFItem,
      items,
      // companyChange,
      userInfo,
      saveOF,
      saveItem,
      setBudget,
      setMaterial,
      validateItem,
      setDeleteOFItem,
      confirmDeleteOFItem,
      cancelDeleteOFItem,
      deleteOFItemID,
      rejectOF,
      numberFormat,
      dateFormat,
      documentPathText,
      lockField,
      uomOptions,
      validateOF,
      calVat,
      calVatRate,
      summaryActualCost,
      onChangeDocumentPath,
      summaryAmount,
      employeeDefault,
      selectedMemo,
      paymentTermAllOptions,
      shippingRecipientOption,
      notYearBudget,
      uomCurrent,
      linkImportXlsx,
      importProcess,
      importFile,
      isProjectBudgetEnable
      // updateMaterialVendor
    }
  }
}
</script>

<style scoped>
.vue-select {
  width: 100%;
  border-radius: 0.375rem;
  border-width: 1px;
  border-color: #e2e8f0;
  border-style: solid;
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
</style>
